define('evicommon/search/search.criteria',['require','exports','module','./search.filter','underscore'],function(require, exports, module){
  var SearchFilter = require('./search.filter');
  var _            = require('underscore');

  var EQUAL_OPERATION = ':';
  var NEGATION_OPERATION = '!';
  var GREATER_THAN_OPERATION = '>';
  var LESS_THAN_OPERATION = '<';
  var LIKE_OPERATION = '~';
  var IS_NULL_OPERATION = '$';
  var NOT_NULL_OPERATION = '^';

  var SEARCH_OPERATIONS = [
    EQUAL_OPERATION,
    NEGATION_OPERATION,
    GREATER_THAN_OPERATION,
    LESS_THAN_OPERATION,
    LIKE_OPERATION,
    IS_NULL_OPERATION,
    NOT_NULL_OPERATION
  ];

  var SEARCH_REGEXP = new RegExp('([^' + SEARCH_OPERATIONS.join('') + ']*)(' + SEARCH_OPERATIONS.join('|') + ')(.*)');

  var SearchCriteria = SearchFilter.extend({

    defaults: function() {
      return { operation: EQUAL_OPERATION };
    },

    importFromStringAndFields: function(search, fields) {
      var match = String(search).match(SEARCH_REGEXP);

      if (!match) { return this; }

      var fieldName = match[1],
          field     = fieldName;

      if (fields) {
        field = fields.findWhere({ name: fieldName });
      }

      if (!field) { return this; }

      this.set({
        field: field,
        operation: match[2],
        value: match[3]
      });

      return this;
    },

    isNull: function() {
      this.operation(IS_NULL_OPERATION);
      this.value('null');
      return this;
    },

    notNull: function() {
      this.operation(NOT_NULL_OPERATION);
      this.value('null');
      return this;
    },

    equals: function(value) {
      this.operation(EQUAL_OPERATION)
      this.value(value);
      return this;
    },

    notEquals: function(value) {
      this.operation(NEGATION_OPERATION);
      this.value(value);
      return this;
    },

    greaterThan: function(value) {
      this.operation(GREATER_THAN_OPERATION);
      this.value(value);
      return this;
    },

    lessThan: function(value) {
      this.operation(LESS_THAN_OPERATION);
      this.value(value);
      return this;
    },

    like: function(value) {
      this.operation(LIKE_OPERATION);
      this.value(value);
      return this;
    },

    contains: function(value) {
      return this.equals('*' + value + '*');
    },

    startsWith: function(value) {
      return this.equals(value + '*');
    },

    endsWith: function(value) {
      return this.equals('*' + value);
    },

    toQuery: function() {
      return this.name() + this.operation() + this.value();
    }

  },
  {
    createFromStringAndFields: function(value, fields) {
      var model = new this().importFromStringAndFields(value, fields);

      if (model.get('field').has('name')) {
        return model;
      }
      return null;
    }

  });

  SearchCriteria.Collection = SearchFilter.Collection.extend({

    model: SearchCriteria,

    importFromStringAndFields: function(values, fields) {
      if (_.isString(values)) {
        values = values.split(',')
      } else {
        values = [];
      }

      var values = _.chain(values)
      .filter(function(value) {
        return !!value;
      })
      .map(function(value) {
        return this.model.createFromStringAndFields(value, fields);
      }, this)
      .filter(function(filter) {
        return !!filter;
      })
      .value()

      this.set(values);
      return this;
    },

    toQuery: function() {
      return this.invoke('toQuery').join(',');
    }

  },
  {
    createFromStringAndFields: function(str, fields) {
      return new this().importFromStringAndFields(str, fields);
    }

  });

  SearchCriteria.EQUAL_OPERATION;
  SearchCriteria.NEGATION_OPERATION;
  SearchCriteria.GREATER_THAN_OPERATION;
  SearchCriteria.LESS_THAN_OPERATION;
  SearchCriteria.LIKE_OPERATION;
  SearchCriteria.SEARCH_OPERATIONS;
  SearchCriteria.SEARCH_REGEXP;
  SearchCriteria.IS_NULL_OPERATION;
  SearchCriteria.NOT_NULL_OPERATION;

  module.exports = SearchCriteria;
});
